import type { Business } from "@/types/directory";
import BusinessCard from "@/components/base/BusinessCard";

interface FeaturedPlacementsProps {
  businesses: Business[];
  loading?: boolean;
}

function FeaturedSkeleton() {
  return (
    <div className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="h-48 w-full animate-pulse bg-background-200" />
      <div className="flex flex-1 flex-col gap-3 p-5">
        <div className="h-3 w-24 animate-pulse rounded-full bg-background-200" />
        <div className="h-4 w-4/5 animate-pulse rounded-full bg-background-200" />
        <div className="h-3 w-3/5 animate-pulse rounded-full bg-background-200" />
        <div className="mt-auto h-10 w-full animate-pulse rounded-md bg-background-200" />
      </div>
    </div>
  );
}

export default function FeaturedPlacements({
  businesses,
  loading = false,
}: FeaturedPlacementsProps) {
  if (!loading && businesses.length === 0) return null;

  return (
    <section
      className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
      aria-label="Featured listings"
    >
      <div className="flex flex-wrap items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className="ri-vip-crown-2-line text-lg" />
        </span>
        <div>
          <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
            Featured Listings
          </h2>
          <p className="text-xs text-foreground-500">Handpicked businesses in this category</p>
        </div>
        {!loading && businesses.length > 0 ? (
          <span className="ml-auto inline-flex items-center whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
            {businesses.length} featured
          </span>
        ) : null}
      </div>

      <div className="mt-5 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {loading
          ? Array.from({ length: 3 }).map((_, index) => <FeaturedSkeleton key={index} />)
          : businesses.map((business) => (
              <BusinessCard key={business.id} business={business} clickableCard />
            ))}
      </div>
    </section>
  );
}